// extracted by mini-css-extract-plugin
module.exports = {"description":"_3oqnqxvZcX_WyoxjqSHUdO"};